module.exports = __webpack_public_path__ + "902a1243b9b93ab77f033d26194e5843.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/Assets/fruitserve.png
// module id = 1366
// module chunks = 0